export const quickEntries = [
  { icon: 'ri-calendar-line', label: '两天一夜', color: 'bg-bamboo-pale text-bamboo' },
  { icon: 'ri-parent-line', label: '亲子游', color: 'bg-bamboo-pale text-bamboo' },
  { icon: 'ri-rainy-line', label: '雨天可去', color: 'bg-[#E3F0F3] text-stream' },
  { icon: 'ri-camera-line', label: '咖啡拍照', color: 'bg-[#FDF2D8] text-tea' },
];

export const categories = [
  { icon: 'ri-restaurant-line', label: '吃饭', color: 'bg-bamboo-pale' },
  { icon: 'ri-cup-line', label: '咖啡', color: 'bg-[#FDF2D8]' },
  { icon: 'ri-landscape-line', label: '景点', color: 'bg-bamboo-pale' },
  { icon: 'ri-home-smile-line', label: '民宿', color: 'bg-[#FDF2D8]' },
  { icon: 'ri-parent-line', label: '亲子', color: 'bg-bamboo-pale' },
  { icon: 'ri-tent-line', label: '露营', color: 'bg-[#FDF2D8]' },
  { icon: 'ri-team-line', label: '团建', color: 'bg-bamboo-pale' },
  { icon: 'ri-camera-line', label: '拍照', color: 'bg-[#FDF2D8]' },
];

export const recommendRoutes = [
  {
    id: 'route-1',
    title: '亲子两天一夜',
    subtitle: '适合带娃家庭的轻松路线',
    spots: 6,
    duration: '两天一夜',
    tag: '亲子',
    image: 'https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=400&h=240&fit=crop',
  },
  {
    id: 'route-2',
    title: '情侣咖啡拍照',
    subtitle: '网红咖啡与浪漫风景',
    spots: 5,
    duration: '一日游',
    tag: '拍照',
    image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&h=240&fit=crop',
  },
  {
    id: 'route-3',
    title: '夏季避暑玩水',
    subtitle: '漂流、溪水和山谷清凉',
    spots: 7,
    duration: '两天一夜',
    tag: '避暑',
    image: 'https://images.unsplash.com/photo-1533240332313-0db49b459ad6?w=400&h=240&fit=crop',
  },
  {
    id: 'route-4',
    title: '云上草原两天一夜',
    subtitle: '高山草原与刺激项目',
    spots: 5,
    duration: '两天一夜',
    tag: '户外',
    image: 'https://images.unsplash.com/photo-1500534623283-312aade485b7?w=400&h=240&fit=crop',
  },
];

export const businessRecommendations = [
  {
    id: 'biz-1',
    placeId: 'laolijia',
    name: '老李家土菜馆',
    type: '顺路吃饭推荐',
    area: '递铺街道',
    tag: '土鸡汤',
    price: '人均 80',
    image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=300&h=200&fit=crop',
  },
  {
    id: 'biz-2',
    placeId: 'waterfall-coffee',
    name: '瀑布咖啡',
    type: '拍照很出片',
    area: '山川乡',
    tag: '山谷咖啡',
    price: '人均 45',
    image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=300&h=200&fit=crop',
  },
  {
    id: 'biz-3',
    placeId: 'alila-anji',
    name: '阿丽拉安吉',
    type: '度假民宿推荐',
    area: '天荒坪',
    tag: '设计感',
    price: '人均 600+',
    image: 'https://images.unsplash.com/photo-1587061949409-02df41d5e562?w=300&h=200&fit=crop',
  },
];